import { WebRequest } from 'framework-ui-components';

export const contatori = codiceUfficio => WebRequest.get('ElaborazioniMassive/Contatori', { codiceUfficio });

export const contatoriDettagli = (codiceUfficio, id) => WebRequest.get('ElaborazioniMassive/ContatoriDettagli', { codiceUfficio, id });

export const elaborazioneMassiva = id => WebRequest.get('ElaborazioniMassive/Elaborazione', { id });

export const risultatoDisponibile = (id, codiceUfficio) => WebRequest.get('ElaborazioniMassive/RisultatoDisponibile', { id, codiceUfficio });
